import useAuth from '../auth';

export const useIsCreator = (creatorId?: string) => {
  const { id } = useAuth();

  return id === creatorId;
};
